<div class="app-wrapper">
  <h1 class="app-h1">{{ title() | translate }}</h1>
  <div class="app-article">
    <div [innerHTML]="text()"></div>
    <footer class="agreement-actions">
    <button
      id="cancelButton"
      class="agreement-button agreement-button--cancel"
      mat-button
      (click)="cancel()"
    >
      {{ "Cancel" | translate }}
    </button>
    <button
      id="agreeButton"
      class="agreement-button agreement-button--agree"
      [disabled]="!isRead"
      mat-flat-button
      type="submit"
      (click)="agree()"
    >
      {{ "Agree" | translate }}
    </button>
    </footer>
  </div>
  <app-scroll-bottom [isVisible]="!isRead"></app-scroll-bottom>
</div>
